import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/key-account-networks/create',
    name: 'keyAccountNetworkCreate',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/key-account-network/KeyAccountNetworkCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_NETWORK_CREATE_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  },
  {
    path: '/key-account-networks/:networkId/edit',
    name: 'keyAccountNetworkUpdate',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/key-account-network/KeyAccountNetworkUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_NETWORK_UPDATE_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  },
  {
    path: '/key-account-networks/:networkId',
    name: 'keyAccountNetworkDetail',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/key-account-network/KeyAccountNetworkDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_NETWORK_READ_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  },
  {
    path: '/key-account-networks',
    name: 'keyAccountNetworks',
    component: () =>
      import('@/views/restricted/key-account-networks/KeyAccountNetworkLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_NETWORK_READ_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  }
]
